<template>
  <v-app>
    <div id="app" :class="classes">
      <div class="page-wrapper">
        <web-menu
          :showSideMenu.sync="showSideMenu"
          v-if="showHeader"
          ref="webMenu"
        ></web-menu>
        <web-header
          :showSideMenu.sync="showSideMenu"
          v-if="showHeader"
          @toggleSideBar="$refs.webMenu.toggleSideBar()"
        />
        <router-view style="min-height: 100vh" />
      </div>
      <web-footer v-if="showFooter" />
      <bx-notification v-if="loading" position="bottom-left" color="primary"
        >Loading</bx-notification
      >
    </div>
  </v-app>
</template>

<script>
import WebFooter from "@/components/layout/WebFooter";
import WebHeader from "@/components/layout/WebHeader";
import WebMenu from "@/components/layout/WebMenu";
import BxNotification from "./bx-components/BxNotification";

export default {
  components: {
    BxNotification,
    WebFooter,
    WebHeader,
    WebMenu
  },
  data() {
    return {
      menuVisible: true
    };
  },
  computed: {
    classes() {
      const classes = ["page", `page-${this.$route.name}`];
      if (this.$route.name !== "login") {
        classes.push("with-header");

        if (this.menuVisible) {
          classes.push("with-menu");
        }
      }

      return classes;
    },
    showHeader() {
      return this.$route.name !== "login";
    },
    showFooter() {
      return this.$route.name !== "login";
    },
    loading() {
      return false; // $store.state.loading
    },
    showSideMenu: {
      get() {
        return this.$store.getters.showSideMenu;
      },
      set(data) {
        this.$store.dispatch("setSideMenu", data);
      }
    }
  }
};
</script>
